import CancelAssessment from "../../../../assets/images/pre-assessment.svg";
import { getTranslatedText } from "../../../../utils/getTranslatedText";

import Modal from "../../../modal/Modal";

import Button from "../ButtonComponent";

import { BUTTON_VARIANTS } from "../constant";
import { useGetTranslatedText } from "../queries";

import styles from "./styles.module.scss";

const ExitLearningModal = (props) => {
  const {show , handleContinueLearning , handleExit} = props;

  const languageId = localStorage.getItem("l_id") || 1;
  
  const {data:translatedTextResponse} = useGetTranslatedText(languageId)
    
  const {data:translatedText = []} = translatedTextResponse || {};

  return (
    <>
      <Modal visible={show}>
        <div className={styles["feedback-wrapper"]}>
          <div className={styles["success-image"]}>
            <img src={CancelAssessment} alt="success" />
          </div>
          <div className={styles.title}>{getTranslatedText(translatedText , 'key_exit_learning' ,'Exit Learning?')}</div>
          <div className={styles.description}>
            {getTranslatedText(translatedText , "key_return_anytime","You can return anytime to continue learning.")}
          </div>

          <div className={styles["button-wrapper"]}>
            <Button
              label={getTranslatedText(translatedText,"key_continue_learning" , "Continue Learning")}
              buttonVariant={BUTTON_VARIANTS.PRIMARY}
              onClick={handleContinueLearning}
            />
            <Button
              label={getTranslatedText(translatedText , "key_exit_anytime" , "Exit")}
              buttonVariant={BUTTON_VARIANTS.SECONDARY}
              onClick={handleExit}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ExitLearningModal;
